import { company_name } from "@/i18n/variables";

const inputs = {
	account_type: {
		label: "Select your account type",
		values: {
			business: "Business",
			private: "Private",
		},
	},
	address: {
		label: "Address",
		placeholder: "For example Manchester Road 1",
	},
	categories: {
		label: "Labels",
	},
	city: {
		label: "City",
		placeholder: "For example Manchester",
	},
	city_of_birth: {
		label: "City of birth",
		placeholder: "City of birth",
	},
	coc_number: {
		label: "CoC number",
		placeholder: "For example 74698818",
	},
	company_name: {
		label: "Company name",
		placeholder: `For example ${company_name}`,
	},
	company_number: {
		label: "-number",
		placeholder: "-number",
	},
	country: {
		label: "Country",
		placeholder: "For example Germany",
	},
	country_of_birth: {
		label: "Country of birth",
		placeholder: "Country of birth",
	},
	country_select: {
		label: "Select your country of origin",
	},
	created_at: {
		label: "Added at",
	},
	date_of_birth: {
		label: "Date of birth",
	},
	department: {
		label: "Department name",
		placeholder: "For example procurement",
	},
	description: {
		label: "Description",
		placeholder: "Description",
	},
	email_address: {
		label: "Email address",
		placeholder: `For example info@${company_name}.nl`,
	},
	email_address_billing: {
		info: "Your invoices will be sent to this address.",
		label: "Billing email address",
		placeholder: `For example administration@${company_name}.nl`,
	},
	email_address_reminders_and_warnings: {
		label: "Different e-mail addresses for reminders and dunning letters",
		placeholder: `For example administration@${company_name}.nl`,
	},
	family_name: {
		label: "Last name",
		placeholder: "For example Janssen",
	},
	given_name: {
		label: "First name",
		placeholder: "For example Henk",
	},
	house_number: {
		label: "House number",
		placeholder: "For example 29",
	},
	house_number_appendix: {
		label: "Addition",
		placeholder: "For example D",
	},
	house_number_with_appendix: {
		label: "House number and addition",
		placeholder: "For example 29",
	},
	identification_issue_date: {
		label: "Identification Issue Date",
	},
	identification_issuer: {
		label: "Identification Issuer",
		placeholder: "For example, Mayor of Manchester",
	},
	identification_number: {
		label: "Identification Number",
		placeholder: "For example 0000000001",
	},
	ip_address: {
		label: "IP address",
	},
	language: {
		label: "Language",
		label_alt: "Communication Language",
		language_list: {
			de: "German",
			en: "English",
			nl: "Dutch",
		},
	},
	last_login: {
		label: "Last logged in on",
	},
	membership_type: {
		label: "Account type",
		values: {
			business: "Business",
			private: "Private",
		},
	},
	middle_name: {
		label: "Middle name",
		placeholder: "For example van der",
	},
	name: {
		label: "Name",
	},
	otp: {
		label: "Enter your 2FA code",
		placeholder: "For example 129432",
	},
	password: {
		label: "Password",
		placeholder: "Use at least 12 characters, including numbers, letters, and symbols",
	},
	password_current: {
		label: "Current password",
		placeholder: "Your current password",
	},
	password_new: {
		label: "New password",
		placeholder: "Use at least 12 characters, including numbers, letters, and symbols",
	},
	password_new_repeat: {
		label: "Repeat new password",
		placeholder: "Repeat your new password",
	},
	password_repeat: {
		label: "Repeat password",
		placeholder: "Repeat your password",
	},
	phone_number: {
		duplicate_dial_code:
			'Note: The country you originally selected may be different because several countries use the country code "{{dial_code}}". This does not affect the stored phone number.',
		info: "We will call you on this number if we have questions about your invoices.",
		label: "Phone number",
		placeholder: "e.g. 6 1234 5678",
	},
	private_network_description: {
		label: "Description",
		placeholder: "Description of your private network",
	},
	private_network_name: {
		label: "Name",
		placeholder: "Name of your private network",
	},
	province: {
		label: "Province",
		placeholder: "Province",
	},
	relation_autocomplete: {
		add_new: "Add new relation",
		label: "Select relationship",
		placeholder: "Select or create a new relationship",
	},
	salutation: {
		label: "Salutation",
		values: {
			d: "Department",
			department: "Department",
			f: "Ms.",
			female: "Ms.",
			m: "Mr.",
			male: "Mr.",
		},
	},
	street_name: {
		label: "Street name",
		placeholder: "For example Main Street",
	},
	trademark_country: {
		label: "Trademark country",
		placeholder: "Trademark country",
	},
	trademark_name: {
		label: "Trademark name",
		placeholder: "Trademark name",
	},
	trademark_number: {
		label: "Trademark number",
		placeholder: "Trademark number",
	},
	user_select: {
		label: "User",
		placeholder: "Select a user",
	},
	username: {
		label: "Username",
		new_user_placeholder: "For example james",
		placeholder: "For example james@DB0001",
	},
	vat_number: {
		label: "VAT number",
		placeholder: "For example NL859996657B01",
	},
	zip_code_of_birth: {
		label: "Postal code birth place",
		placeholder: "For example 1234 AB",
	},
	zipcode: {
		label: "Postal code",
		placeholder: "For example 1234 AB",
	},
};

export default inputs;
